module.exports = __webpack_public_path__ + "img/pause1.9efea213.png";